<template>
  <div v-if="loading" class="preview-multi-select">
    <b>{{ filtro.name }}:</b> <span>{{ $i18n('interface.novo_filtro.selecione') }}</span>
  </div>
  <Select
    v-else
    :items="arrayTransportadoras"
    :selectedItem="filter.transportadora"
    :label="filtro.name"
    :searchPlaceholder="$i18n('interface.novo_filtro.buscar_transportadora')"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
    :buscaRemota="true"
    :buscando="buscando"
    @atualizar="atualizar"
    @buscar="buscarTransportadoras"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        transportadora: {
          id: '',
          name: '',
        },
      },
      arrayTransportadoras: [],
      loading: true,
      buscando: false,
      termoAtual: '',
    };
  },
  methods: {
    atualizar(transportadora) {
      this.filter.transportadora = transportadora;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.transportadora.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.transportadora.id
      });
    },
    buscarTransportadoras(term = '') {
      this.buscando = true;
      this.termoAtual = term;
      this.$api.get('/stakeholders/busca_todos', { params: { tipos: ['transportadora'], term } }).then(response => {
        if (this.termoAtual !== term) return;
        const stakeholders = response.data;
        this.arrayTransportadoras = stakeholders.map(stakeholder => ({
          id: stakeholder.id,
          name: stakeholder.label,
        }));
        const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
        this.$renderFiltroSelect(filtroAplicado, this.arrayTransportadoras, this.filter.transportadora);
      }).catch(error => {
        if (this.termoAtual !== term) return;
        console.error('Erro ao buscar transportadoras:', error);
      }).finally(() => {
        if (this.termoAtual === term) {
          this.buscando = false;
          this.loading = false;
        }
      });
    },
  },
  mounted() {
    this.buscarTransportadoras();
  },
}
</script>
